export default function WhatWeRepair() {
  const items = [
    "Crémone bloquée ou cassée : remplacement du mécanisme de verrouillage avec pièce adaptée au bois",
    "Poignée qui force ou qui tourne dans le vide : changement de la poignée et de l'axe d'entraînement",
    "Fenêtre qui gonfle et ferme mal en été : réglage de la compression et des joints",
    "Fenêtre qui frotte dans le dormant : réglage des gonds et allègement du vantail",
    "Gond ou paumelle écrasée par le poids du vantail : remplacement par un modèle renforcé",
    "Joint de vitrage ou de dormant durci : remplacement pour retrouver l'étanchéité à l'air",
    "Fermeture oscillo-battant qui déraille : recalage des ciseaux et des galets de compression",
    "Anti-fausse manœuvre défectueux : remplacement pour rétablir la double ouverture sécurisée",
  ];

  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-4 md:mb-6">
            Ce que nous réparons sur une fenêtre Bois
          </h2>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-6 md:mb-8">
            Le bois demande une quincaillerie spécifique et un réglage qui tient compte de la dilatation naturelle du matériau. Nos techniciens arrivent avec un diagnostic portable et des pièces adaptées aux fenêtres en bois. Voici les interventions les plus fréquentes que nous réalisons chez vous en une seule visite dans le Bas-Rhin.
          </p>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-6 md:mb-8">
            Nous ne remplaçons pas ce qui est réparable. Si le mécanisme peut être réglé, décalé ou resserré pour compenser le mouvement du bois, nous le faisons d'abord. Si la pièce est trop usée, nous la changeons avec une pièce neuve compatible et nous réajustons la fenêtre. Chaque intervention est testée sur place : fermeture, compression, étanchéité à l'air et fonctionnement fluide de la poignée.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
            {items.map((item) => (
              <div key={item} className="flex items-start gap-3 bg-white rounded-2xl p-4 md:p-5 border border-rose-100">
                <div className="w-6 h-6 rounded-full bg-coral/10 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-check-line text-coral text-sm" />
                </div>
                <p className="text-sm md:text-base text-plum-dark leading-relaxed">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}